import React from 'react';
import Logo from '../icon-img/UPES-logo.png'; // Update with the correct logo path

const Thankyou = () => {
 

  return (
    <section className="d-flex justify-content-center  vh-100 ">
      <div className="text-center p-4 mt-5">
        <div className="mb-3">
          <img src={Logo} alt="Logo" className="img-fluid text-center"  />
        </div>
        <h1 className="text-dark mt-5">🎉 Thank You! 🎉</h1>
        <hr />
       <div className="text mt-4">
       <p>Your form has been successfully submitted.</p>
       <p>We will get back to you soon!</p>
       </div>
       <a href="/" className="btn btn-dark mt-3">Go Home</a>
      </div>
    </section>
  );
};

export default Thankyou;
